export const isInIFrame = () => {
  if (window.top !== window.self) return true;
  return false;
};
